import moment from 'moment'
import 'moment/locale/zh-cn'
import currency from './currency/currency.js'
import numberF from './number/number.js'
import percent from './percent/percent'
import progress from './progress/progress'

/**
全局过滤器
 * @param {String} type 过滤方式
 * @param {String,Number} format 过滤格式（如选择date时可为YYYY-MM-DD HH:mm:ss）
 * @param {String} symbol 某些过滤方式可选（如选择currency时可为金额前的单位￥、$）
*/
const filter = function (value, type, format, symbol) {
  switch (type) {
    case 'currency':
      return currency(value, format, symbol)
    case 'number':
      return numberF(value, format, symbol)
    case 'date': // 日期时间的格式：YYYY-MM-DD HH:mm:ss
      if (!value) return value
      return moment(value).format(format?.replace('yyyy-MM-dd', 'YYYY-MM-DD'))
    case 'percent':
      if (!value && value !== 0) return value
      return percent(value, format, symbol)
    case 'progress':
      if (!value && value !== 0) return value
      return progress(value, format, symbol)
    default:
      return value
  }
}

const filters = {
  install: function (Vue) {
    Vue.filter('formatFilter', filter)
  },
}

Date.prototype.format = filter
export { filters, filter, moment }
